<template>
    <div v-if="themeStore.themeIndex === 1">
         <AgentPopup :data-set="dataSet" @onClickTab="onClickTab" @close="close"  v-model:show="show"/>
    </div>
    <div v-if="themeStore.themeIndex === 2">
         <AgentPopupTwo :data-set="dataSet" @onClickTab="onClickTab" @close="close"  v-model:show="show"/>
    </div>
    <div v-if="themeStore.themeIndex === 3">
         <AgentPageThree :data-set="dataSet" @onClickTab="onClickTab" @close="close"  v-model:show="show"/>
    </div>
    <div v-if="themeStore.themeIndex === 4">
         <AgentPageFour :data-set="dataSet" @onClickTab="onClickTab" @close="close"  v-model:show="show"/>
    </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n';
import { useActivityStore } from '@/stores/activity';
import { AgentData } from './supportScript';
import AgentPopup from '@/themes/themeOne/agent/agentPopup.vue';
import AgentPopupTwo from '@/themes/themeTwo/agent/agentPopup.vue';
import { useThemeStore } from '@/stores/theme';
import AgentPageThree from '@/themes/themeThree/agent/agentPage.vue';
import AgentPageFour from '@/themes/themeFour/agent/agentPage.vue';

const { t } = useI18n();
const show = ref(false)
const activityStore = useActivityStore()
const bannerImage = ref('')
const active = ref(0)
const route = useRoute()
const activeTab = ref(route.query.tab ? Number(route.query.tab) : 0)
const emits = defineEmits(['handleCloseagent', 'openPromotion'])
const themeStore = useThemeStore()

const dataSet = computed<AgentData>(() => ({
    show:show.value,
    bannerImage:bannerImage.value,
    activeTab:activeTab.value,
}))
const open = (data: any) => {
    show.value = true
    if(data){
        activeTab.value = data
    }else{
        activeTab.value = 0
    }
    let activityList = computed(() => activityStore.activityList)
    let agentConfig = activityList.value.find(
        (item:any) => item.name === 'agent_cash_back'
    ) || null;
    bannerImage.value = agentConfig?.floatIcon
}
const close = () => {
    activeTab.value = 0
    active.value = 0
    show.value = false
    emits('handleCloseagent')
    if(localStorage.getItem('agentOpenFromPromotion') == 'true'){
        localStorage.setItem('footerPopupOpen', '3')
        localStorage.setItem('openPromotionPopup', 'true')
        emits('openPromotion')
        localStorage.setItem('agentOpenFromPromotion', 'false')
    }
    
}
const onClickTab = (value: any) => {
    activeTab.value = value.name
}

defineExpose({
    open,
    close
})
</script>
